const address = {
  'address.title': 'إدارة العناوين',
  'address.address': 'عنوان الاستلام',
  'address.address.placeholder': 'الرجاء اختيار عنوان الاستلام',
  'address.add': 'إضافة',
  'address.addAddress': 'إضافة عنوان',
  'address.edit': 'تعديل',
  'address.editAddress': 'تعديل العنوان',
  'address.delete': 'حذف',
  'address.deleteAddress': 'حذف العنوان',
  'address.default': 'افتراضي',
  'address.defaultAddress': 'العنوان الافتراضي',
  'address.setDefault': 'تعيين كافتراضي',
  'address.setDefaultAddress': 'تعيين كعنوان افتراضي',
  'address.switch': 'تبديل',
  'address.switchAddress': 'تبديل العنوان',

  'address.country': 'الدولة',
  'address.country.placeholder': 'الرجاء إدخال الدولة',
  'address.country.maxLength': 'يجب ألا يتجاوز اسم الدولة {total} حرفًا',
  'address.state': 'الولاية/المحافظة',
  'address.state.placeholder': 'الرجاء إدخال الولاية/المحافظة',
  'address.state.maxLength': 'يجب ألا يتجاوز الاسم {total} حرفًا',
  'address.city': 'المدينة',
  'address.city.placeholder': 'الرجاء إدخال المدينة',
  'address.city.maxLength': 'يجب ألا يتجاوز اسم المدينة {total} حرفًا',
  'address.street': 'الشارع',
  'address.street.placeholder': 'الرجاء إدخال اسم الشارع',
  'address.street.maxLength': 'يجب ألا يتجاوز اسم الشارع {total} حرفًا',
  'address.detail': 'العنوان التفصيلي',
  'address.detail.placeholder': 'الرجاء إدخال العنوان التفصيلي',
  'address.detail.maxLength': 'يجب ألا يتجاوز العنوان التفصيلي {total} حرفًا',

  'address.recipient_name': 'اسم المستلم',
  'address.recipient_name.placeholder': 'الرجاء إدخال اسم المستلم',
  'address.recipient_name.maxLength': 'يجب ألا يتجاوز اسم المستلم {total} حرفًا',
  'address.recipient_name.minLength': 'يجب ألا يقل اسم المستلم عن {total} حرفًا',
  'address.recipient_name.pattern': 'يجب أن يحتوي الاسم على أحرف صينية/إنجليزية ومسافات فقط',

  'address.phone': 'رقم الاتصال',
  'address.phone.placeholder': 'الرجاء إدخال رقم هاتف صحيح (مثال: +966 500000000)',
  'address.phone.maxLength': 'يجب ألا يتجاوز الرقم {total} حرفًا',
  'address.phone.pattern': 'الرجاء إدخال رقم هاتف صحيح مع رمز الدولة',

  'address.postal_code': 'الرمز البريدي',
  'address.postal_code.placeholder': 'الرجاء إدخال رمز بريدي صحيح',
  'address.postal_code.maxLength': 'يجب ألا يتجاوز الرمز البريدي {total} حرفًا',
  'address.postal_code.pattern': 'الرجاء إدخال رمز بريدي صالح',

  'address.updateSuccess': 'تم تحديث العنوان بنجاح',
  'address.createSuccess': 'تمت إضافة العنوان بنجاح',
  'address.deleteSuccess': 'تم حذف العنوان بنجاح',
  'address.setDefaultSuccess': 'تم تعيين العنوان الافتراضي بنجاح',

  'address.confirmDelete': 'تأكيد حذف هذا العنوان؟',
};

export default address;
